module.exports = __webpack_public_path__ + "img/payhandle.2e07d651.png";